import { useHovered } from '../../utils/useHovered';
export const HoverProvider = props => {
  return props.children(useHovered(props));
};
HoverProvider.displayName = 'HoverProvider';